import { render } from "./XIconSolidMicrosoftTeamsLogo.vue?vue&type=template&id=52fb7881"
import script from "./XIconSolidMicrosoftTeamsLogo.vue?vue&type=script&lang=js"
export * from "./XIconSolidMicrosoftTeamsLogo.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidMicrosoftTeamsLogo.vue"]])

export default __exports__